import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import InvoiceForm from "@components/forms/InvoiceForm";
import AddProductToDocumentOffCanvas from "@components/layout/Offcanvas/AddProductToDocumentOffCanvas";
import AddClientOffCanvas from "@components/layout/Offcanvas/AddClientOffCanvas";
import DocumentReferencesOffCanvas from "@components/layout/Offcanvas/DocumentReferencesOffCanvas";
import DocumentOtherChargesOffCanvas from "@components/layout/Offcanvas/DocumentOtherChargesOffCanvas";
import ShippingCostOffCanvas from "@components/layout/Offcanvas/ShippingCostOffCanvas";
import { ClientDataType } from "@/api/ClientApi";
import { AddClientToDocumentPubSub, LoadInvoiceTemplatePubSub, OpenDocumentExemptionPubSub, OpenDocumentOtherChargesPubSub, OpenDocumentReferencesPubSub, OpenShippingCostPubSub } from "@utils/pubsubs/PubSub";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { clearAllProductsExemptionData, clearDefaultExemption } from "@/store/slices/eDocumentSlides";
import { InvoiceTemplateDataType } from "@/api/InvoiceTemplateApi";
import { selectDocumentSummary } from "@/store/slices/utils/eDocumentSelectors";

type InvoiceAddProps = {
  copyData?: boolean
}

const InvoiceAdd = (props: InvoiceAddProps) => {
  const { copyData = false } = props
  const documentSummary = useAppSelector(selectDocumentSummary);
  const dispatch = useAppDispatch()
  const defaultExemption = useAppSelector((state) => state.eDocument.defaultExemption)
  const documentReferences = useAppSelector((state) => state.eDocument.documentReferences)
  const documentOtherCharges = useAppSelector((state) => state.eDocument.documentOtherCharges)
  const params = useParams()
  const { id: copyInvoiceId, quoteId } = params;

  useEffect(() => {
  }, []);

  const onClientStored = (clientData?: ClientDataType) => {
    if (clientData) {
      AddClientToDocumentPubSub.publish({ client: clientData })
    }
  }

  const onTemplateSelect = (invoiceTemplate: InvoiceTemplateDataType) => {
    LoadInvoiceTemplatePubSub.publish({ invoiceTemplate })
  }

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title="Agregar Factura"
      backUrl="/user/invoices"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "invoiceAdd",
          type: "submit",
          color: "success"
        },
        {
          customElement: (
            <AddProductToDocumentOffCanvas
              onTemplateSelect={onTemplateSelect}
              btnColor="success">
              Agregar Producto
            </AddProductToDocumentOffCanvas>
          )
        }
      ]}
      secondaryActions={[
        {
          actionTitle: "Nueva Factura",
          href: "/user/invoices/add",
          target: "_blank"
        },
        {
          actionTitle: `${defaultExemption ? "Editar" : "Agregar"} Exoneracion a Documento`,
          onClick: () => {
            if (defaultExemption) {
              OpenDocumentExemptionPubSub.publish({
                openOffCanvas: true,
                defaultData: defaultExemption,
                lineSubtotal: defaultExemption.lineSubtotal || 0
              })
            } else {
              OpenDocumentExemptionPubSub.publish({
                openOffCanvas: true,
                defaultData: { monto_impuesto: documentSummary.impuestos, porcentaje_compra: "13" },
                lineSubtotal: documentSummary.subtotal
              })
            }
          }
        },
        {
          isVisible: !!defaultExemption,
          actionTitle: `Eliminar Exoneracion`,
          onClick: () => {
            dispatch(clearAllProductsExemptionData())
            dispatch(clearDefaultExemption())
          }
        },
        {
          actionTitle: `Referencias de Documento (${documentReferences.length})`,
          onClick: () => {
            OpenDocumentReferencesPubSub.publish({ openOffCanvas: true, documentKind: "Invoice" })
          }
        },
        {
          actionTitle: `Otros Cargos (${documentOtherCharges.length})`,
          onClick: () => {
            OpenDocumentOtherChargesPubSub.publish({ openOffCanvas: true, documentKind: "Invoice" })
          }
        },
        {
          actionTitle: "Agregar Costo de Envio",
          onClick: () => {
            OpenShippingCostPubSub.publish({ openOffCanvas: true, documentKind: "Invoice" })
          }
        },
      ]}
    >
      <InvoiceForm
        id={copyInvoiceId}
        quoteId={quoteId}
        copyData={copyData}
        saveRedirectUrl="/user/invoices"
        formId="invoiceAdd" >
      </InvoiceForm>

      <AddClientOffCanvas
        onStored={onClientStored} />

      <DocumentReferencesOffCanvas />

      <DocumentOtherChargesOffCanvas />

      <ShippingCostOffCanvas />

    </PageContainer>
  );
}

export default InvoiceAdd;
